import React from 'react'
import { motion } from 'framer-motion'
import P1 from '../../images/vv1.png'
import P2 from '../../images/vv2.png'
import P3 from '../../images/vv3.png'
import AnimateIn, { StaggerContainer, StaggerItem } from '../AnimateIn'

function Services() {
    const visaList = [
        { title: 'Visitor Visas & Records', description: 'Enter Canada and extend your stay' },
        { title: 'Super Visas', description: 'Invite your parents and grandparents to visit long-term' },
        { title: 'Study Permits', description: 'Pursue an education at the elementary, secondary, or post-secondary level' },
        { title: 'Post-Graduation Work Permits', description: 'Work in Canada after post-secondary graduation' },
        { title: 'Bridging Open Work Permits', description: 'Work in Canada while your permanent residence application is being processed' },
        { title: 'LMIA-Based Work Permits', description: 'Employer-specific work permits' }
      ];

      const immigrationList = [
         { title: 'Canadian Experience Class (Express Entry)', description: 'For professionals with Canadian work experience' },
        { title: 'Federal Skilled Workers (Express Entry)', description: 'For professionals with international work experience' },
        { title: 'Provincial Nominees', description: 'For people selected for permanent residence by a province or territory' },
        { title: 'Spouse & Common-Law Sponsorships', description: 'Help your spouse or partner immigrate' },
        { title: 'Parent & Grandparent Sponsorships', description: 'Help your parents and grandparents immigrate' },
        { title: 'Child Sponsorships', description: 'Help your children immigrate' },
        { title: 'Other Relative Sponsorships', description: 'Help other relatives immigrate (allowed under special circumstances)' },
        { title: 'Humanitarian & Compassionate', description: 'Stay in Canada for exceptional reasons' },
      ];

      const otherServicesList = [
        { title: 'Non-Criminal Temporary Resident Permits', description: 'Temporarily overcome an inadmissibility' },
        { title: 'Medical Inadmissibility', description: 'Permanently overcome a medical inadmissibility' },
        { title: 'Citizenship', description: ' Apply for citizenship and proof of citizenship' },
        { title: 'Replacing Documents', description: 'Renew Permanent Resident Cards or correct mistakes on documents' },
        { title: 'Affidavits & Statutory Declarations', description: ' Commission immigration-related documents and forms' },
        { title: 'Access To Information Requests', description: 'Learn the details about why an application was refused' },
        { title: 'Refugee Permanent Residence', description: 'Applications for Convention Refugees' },
        { title: 'Others', description: 'Many other services are available upon request' },
      ];

  return (
    <div id='service' className='sm:py-[96px] py-[48px] overflow-hidden'>

      <AnimateIn from="up" className='sm:px-[90px] px-8'>
        <h1 className='font-[900] text-[28px] sm:text-[46px] text-primary-color text-center sm:w-[75%] mx-auto'>
          What Kelen Immigration Services Can Do For You
        </h1>
      </AnimateIn>

      <div className='sm:px-[90px] px-8'>
        <div className='grid sm:grid-cols-2 gap-10 py-[50px]'>
          <AnimateIn from="left" delay={0.1}>
            <motion.img
              src={P1}
              alt='P1'
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
              className='rounded-lg'
            />
          </AnimateIn>
          <AnimateIn from="right" delay={0.2} className='sm:w-[75%] mx-auto'>
            <h1 className='font-[700] text-[#3A3A3A] text-[32px]'>Visit, Study, Work</h1>
            <motion.div
              className='w-[85%] sm:w-[320px] mb-3 h-1 rounded-full bg-primary-color'
              initial={{ scaleX: 0, originX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            />
            <p className='font-[400] mb-4 text-[20px]'>Kelen Immigration Services offers the following:</p>
            <StaggerContainer staggerDelay={0.06}>
              {visaList.map((e, i) => (
                <StaggerItem key={i}>
                  <ul className="list-disc list-inside space-y-2">
                    <li className='font-[400] mb-3 text-[18px] text-[#3A3A3A]'><span className='font-[500] text-[18px] text-[#3A3A3A]'>{e.title}</span> - {e.description}</li>
                  </ul>
                </StaggerItem>
              ))}
            </StaggerContainer>
          </AnimateIn>
        </div>
      </div>

      <div className='w-full h-2 bg-[#F5F5F5]'></div>

      <div className='sm:px-[90px] px-8'>
        <div className='grid sm:grid-cols-2 gap-10 py-[50px]'>
          <AnimateIn from="left" delay={0.1} className='sm:w-[75%] mx-auto'>
            <h1 className='font-[700] text-[#3A3A3A] text-[32px]'>Stay</h1>
            <motion.div
              className='w-[20%] sm:w-[120px] mb-3 h-1 rounded-full bg-primary-color'
              initial={{ scaleX: 0, originX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            />
            <p className='font-[400] mb-4 text-[20px]'>Kelen Immigration Services offers the following:</p>
            <StaggerContainer staggerDelay={0.06}>
              {immigrationList.map((e, i) => (
                <StaggerItem key={i}>
                  <ul className="list-disc list-inside space-y-2">
                    <li className='font-[400] mb-3 text-[18px] text-[#3A3A3A]'><span className='font-[500] text-[18px] text-[#3A3A3A]'>{e.title}</span> - {e.description}</li>
                  </ul>
                </StaggerItem>
              ))}
            </StaggerContainer>
          </AnimateIn>
          <AnimateIn from="right" delay={0.2}>
            <motion.img
              src={P2}
              alt='P2'
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
              className='rounded-lg'
            />
          </AnimateIn>
        </div>
      </div>

      <div className='w-full h-2 bg-[#F5F5F5]'></div>

      <div className='sm:px-[90px] px-8'>
        <div className='grid sm:grid-cols-2 gap-10 py-[50px]'>
          <AnimateIn from="left" delay={0.1}>
            <motion.img
              src={P3}
              alt='P3'
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
              className='rounded-lg'
            />
          </AnimateIn>
          <AnimateIn from="right" delay={0.2} className='sm:w-[75%] mx-auto'>
            <h1 className='font-[700] text-[#3A3A3A] text-[32px]'>Other</h1>
            <motion.div
              className='w-[20%] sm:w-[120px] mb-3 h-1 rounded-full bg-primary-color'
              initial={{ scaleX: 0, originX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            />
            <p className='font-[400] mb-4 text-[20px]'>Kelen Immigration Services offers the following:</p>
            <StaggerContainer staggerDelay={0.06}>
              {otherServicesList.map((e, i) => (
                <StaggerItem key={i}>
                  <ul className="list-disc list-inside space-y-2">
                    <li className='font-[400] mb-3 text-[18px] text-[#3A3A3A]'><span className='font-[500] text-[18px] text-[#3A3A3A]'>{e.title}</span> - {e.description}</li>
                  </ul>
                </StaggerItem>
              ))}
            </StaggerContainer>
          </AnimateIn>
        </div>
      </div>

    </div>
  )
}

export default Services
